import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Col, PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap';
import { noImage, ProductAddonModel } from '../../shared/orders';
import { useTranslation } from '../translations';
import { displayName, truncateText } from '../utils';
import { Currency } from './Currency';
import { ActionButton, LinkButton, RichMarkdownIt } from '.';

interface RelatedProductProps {
  readonly addon: ProductAddonModel;
}

export const RelatedProduct: FC<RelatedProductProps> = ({ addon }) => {
  const { ts } = useTranslation();
  const image = addon.imageId ? `/api/products/${addon.id}/images/${addon.imageId}` : noImage;
  const hasRequiredOption = addon.options.some((t) => t.required);

  return (
    <Col className="text-center" lg={3} xs={12}>
      <Link to={`/store/product/${addon.id}`}>
        <img
          id={`addon${addon.id}`}
          src={image}
          style={{ maxWidth: '75%', maxHeight: 'auto', borderRadius: '10px', margin: '0 auto' }}
        />
        <div>{addon.name}</div>
      </Link>
      <UncontrolledPopover placement="right" target={`addon${addon.id}`} trigger="hover">
        <PopoverHeader>
          <Link to={`/store/product/${addon.id}`}>{displayName(addon)}</Link>
        </PopoverHeader>
        <PopoverBody>
          <h5>
            <Currency value={addon.price} />
          </h5>
          {addon.description && <RichMarkdownIt source={truncateText(addon.description)} />}
        </PopoverBody>
        <PopoverHeader>
          {hasRequiredOption ? (
            <LinkButton block color="success" to={`/store/product/${addon.id}`}>
              {ts('common.view_product')}
            </LinkButton>
          ) : (
            <ActionButton
              action={async () => {
                await api.addProductToCart(addon.id, { quantity: 1 });
              }}
              block
              color="success"
              onSuccess={() => {
                /* NO-OP */
              }}
            >
              {ts('common.add_to_cart')}
            </ActionButton>
          )}
        </PopoverHeader>
      </UncontrolledPopover>
    </Col>
  );
};
